import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PriceListModel } from '@app/models';

@Injectable({
    providedIn: 'root',
})
export class PriceListService
{
    private endPoint = '/priceLists';
    private http = inject(HttpClient);

    getPriceLists(): Promise<PriceListModel[]>
    {
        return firstValueFrom(this.http.get<PriceListModel[]>(this.endPoint));
    }
}
